// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  titleLogoText: 'PRSPR',
  environmentName: 'production2',
  cookieDomain:'.reach.marketing',
  baseUrl: 'https://prsprapi.reach.marketing',
  apiBaseUrl: 'https://prsprapi.reach.marketing',
  automationsApiBaseUrl: 'https://prsprapi.reach.marketing',
  ffmFrontendUrl:"https://app.reach.marketing/",
  PrsprFrontendUrl:"https://prspr.reach.marketing/",
  cpjpFrontendUrl:"https://cpjp.reach.marketing/",
  loginFrontendUrl:"https://my.reach.marketing/",
  googleAnalyticsId: 'G-0S3Z1MFX5P',
};

/*
* For easier debugging in development mode, you can import the following file
* to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
*
* This import should be commented out in production mode because it will have a negative impact
* on performance if an error is thrown.
*/
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.

